import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseUrl = process.env.REACT_APP_SERVER_URL;

// Dashboard admin : toutes les news (brouillons inclus)
export const getAllNews = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/news`);
    return { news: response.data.news };
  } catch (error) {
    console.error(error);
  }
};

// Page d'accueil : uniquement les news publiées (sans brouillons)
export const getAllPublishedNews = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/news/published`);
    return { news: response.data.news };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedNews = async (
  page: number,
  keyword: string = ""
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/news/all?page=${page}&keyword=${encodeURIComponent(
        keyword
      )}`
    );
    return {
      news: response.data.news,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNewsBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/news/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateNews = async (formData: any, navigate: Function) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "image") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else if (formData[key] instanceof Date) {
            newsFormData.append(key, formData[key].toISOString().split("T")[0]);
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.image && Array.isArray(formData.image)) {
      formData.image.forEach((image: any) => {
        if (image.file) {
          newsFormData.append(`image`, image.file);
        }
      });
    }

    const response = await axios.post(
      `${baseUrl}/api/news/`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/actualités");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Une erreur s'est produite.";
      toast({
        variant: "destructive",
        title: "Une erreur s'est produite.",
        description: message,
        className: "bg-red-500 border border-red-500",
      });
      return message;
    }
  }
};

export const handleUpdateNews = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();

    if (formData.title) {
      formDataToSend.append("title", formData.title);
    }
    if (formData.description) {
      formDataToSend.append("description", formData.description);
    }
    if (formData.date) {
      // Convertir Date en string si nécessaire
      const dateValue =
        formData.date instanceof Date
          ? formData.date.toISOString().split("T")[0]
          : formData.date;
      formDataToSend.append("date", dateValue);
    }
    if (formData.isDraft !== undefined) {
      formDataToSend.append("isDraft", String(formData.isDraft));
    }

    if (formData.image && Array.isArray(formData.image) && formData.image[0]?.file) {
      formDataToSend.append("image", formData.image[0].file);
    }

    const response = await axios.patch(
      `${baseUrl}/api/news/${id}`,
      formDataToSend,
      config
    );

    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: response.data.msg,
      className: "bg-green-500 border border-green-500",
    });
    navigate("/admin-dashboard/actualités");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Une erreur s'est produite.";
      toast({
        variant: "destructive",
        title: "Une erreur s'est produite.",
        description: message,
        className: "bg-red-500 border border-red-500",
      });
      return message;
    }
  }
};

export const deleteNews = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(`${baseUrl}/api/news/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getNewsById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/news/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
